























import Vue from "vue";
import router from "@/router";

export default Vue.extend({
  name: "ForgotPasswordResult",
  components: {},
  data: () => ({
    title: "",
    resetPasswordNoti: {} as any,
    emptyMFA: false,
    countDown: 5,
  }),
  methods: {
    goBack() {
      router.push("/login/forgot-password");
    },
    goToLogin() {
      router.push("/login");
    }
  },
  created() {
    let resetPasswordNoti;
    if (Object.keys(this.$route.params).length) {
      resetPasswordNoti = this.$route.params;
      this.resetPasswordNoti = resetPasswordNoti;
      if (resetPasswordNoti.type === "changePwdSuccess") {
        this.title = "Password changed \n successfully!";
      } else {
        this.emptyMFA = true;
        this.title =
          "MFA (Multi-factor Authentication) is currently not activated.\nPlease contact administrator to recover your account password.";
      }
    }
  },
});
